import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "@apollo/react-hooks";
import {
  MY_DOCUMENTS_DELETE_DOCUMENT,
  MY_DOCUMENTS_UPDATE_DOCUMENT,
} from "my-documents/graphql";
import { MY_DOCUMENTS_GET_LIST } from "my-documents/graphql/queries";
import { useOcSnackbar } from "oc/hooks";

// TODO implement subscription
export const useMyDocumentsList = ({ contractCode }: { contractCode: string }) => {
  const variables = { user: contractCode };

  const { data, loading, error, refetch } = useQuery(MY_DOCUMENTS_GET_LIST, {
    variables,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    skip: !contractCode,
  });

  const { setOpenMessage } = useOcSnackbar();
  const { t } = useTranslation();

  const [updateMyDocumentMutation] = useMutation(MY_DOCUMENTS_UPDATE_DOCUMENT, {
    refetchQueries: [{ query: MY_DOCUMENTS_GET_LIST, variables }],
    awaitRefetchQueries: true,
  });

  const updateMyDocument = useCallback(
    async (options?: any) => {
      try {
        const result = await updateMyDocumentMutation(options);
        setOpenMessage({ type: "success", message: t("OC_USER_UPDATED") });
        return result;
      } catch (error) {
        console.log({ error });
        setOpenMessage({ type: "error", message: t("OC_SAVE_FAILED") });
        throw error;
      }
    },
    [updateMyDocumentMutation, setOpenMessage, t],
  );

  const [deleteMyDocumentMutation] = useMutation(MY_DOCUMENTS_DELETE_DOCUMENT, {
    refetchQueries: [{ query: MY_DOCUMENTS_GET_LIST, variables }],
    awaitRefetchQueries: true,
  });

  const deleteMyDocument = useCallback(
    async (options?: any) => {
      try {
        const result = await deleteMyDocumentMutation(options);
        setOpenMessage({
          type: "success",
          message: t("MY_DOCUMENTS_DOCUMENT_SUCCESSFUL_DELETION"),
        });
        return result;
      } catch (error) {
        console.log({ error });
        setOpenMessage({
          type: "error",
          message: t("MY_DOCUMENTS_DOCUMENT_ERROR_DELETION"),
        });
        throw error;
      }
    },
    [deleteMyDocumentMutation, setOpenMessage, t],
  );

  return {
    data: data?.listMyDocuments || [],
    loading,
    error,
    refetch,
    deleteMyDocument,
    updateMyDocument,
  };
};

export default useMyDocumentsList;
